import Vue from 'vue'
import Router from 'vue-router'
/* 页面 */
import Login from './views/Login.vue'
import Home from './views/Home.vue'
import DeviceStatus from './views/DeviceStatus.vue'
import Frame from './views/Frame.vue'
import Port from './views/Port.vue'
import OntList from './views/OntList.vue'
import Vlan from './views/Vlan.vue'
import Mac from './views/Mac.vue'
import Lacp from './views/Lacp.vue'
import Pppoeplus from './views/PppoeplusConfig.vue'
import Snmp from './views/SnmpConfig.vue'
import GponConfig from './views/GponConfig.vue'
import GponFindOnt from './views/GponFindOntInfo.vue'
import OntBrief from './views/OntBrief.vue'
import OntInfo from './views/OntInfo.vue'
import OntOptical from './views/OntOptical.vue'
import OntMacTableList from './views/OntMacTableList.vue'
import OntUpgrade from './views/OntUpgrade.vue'
import MirrorCfg from './views/Mirror.vue'
import ProfileDba from './views/ProfileDba.vue'
import ProfileVlan from './views/ProfileVlan.vue'
import ProfileUs from './views/ProfileUs.vue'
import ProfileDs from './views/ProfileDs.vue'
import ProfileRule from './views/ProfileRule.vue'
import ProfilelinePri from './views/ProfileLinePri.vue'
import ProfilelineStep from './views/ProfileLineStep.vue'
import ProfileVlanRule from './views/ProfileVlanRule.vue'
import ProfileUnique from './views/ProfileUnique.vue'
import ProfileUniqueConfig from './views/ProfileUniqueConfig.vue'
import ProfileAlarm from './views/ProfileAlarm.vue'
import ProfileMulticast from './views/ProfileMulticast.vue'
import ProfileMulticastEntry from './views/ProfileMulticastEntry.vue'
import ProfileMulticastEntryInfo from './views/ProfileMulticastEntryInfo.vue'
import DeviceManagement from './views/DeviceManagement.vue'
import SystemTime from './views/SystemTime.vue'
import UserConfig from './views/UserConfig.vue'
import AuxIp from './views/AuxIp.vue'
import IpConfig from './views/IpConfig.vue'
import Igmp from './views/Igmp.vue'
import Stp from './views/Stp.vue'
import Dhcp from './views/Dhcp.vue'
import DhcpOption82  from './views/DhcpOption82.vue'
import StormControl from './views/StormControl.vue'
import Diagnose from './views/Diagnose.vue'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/frame',
      name: 'frame',
      component: Frame,
      redirect: '/home',
      children: [{
          path: '/home',
          name: 'home',
          component: Home
        },
        {
          path: '/devicestatus',
          name: 'devicestatus',
          component: DeviceStatus
        },
        {
          path: '/port',
          name: 'port',
          component: Port,
        },
        {
          path: '/statusont',
          name: 'ontlist',
          component: OntList
        },
        {
          path: '/vlan',
          name: 'vlan',
          component: Vlan
        },
        {
          path: '/mac',
          name: 'mac',
          component: Mac
        },
        {
          path: '/lacp',
          name: 'lacp',
          component: Lacp
        },
        {
          path: '/igmp',
          name: 'igmp',
          component: Igmp
        },
        {
          path: '/ipconfig',
          name: 'ipconfig',
          component: IpConfig
        },
        {
          path: '/pppoeplus',
          name: 'pppoeplus',
          component: Pppoeplus
        },
        {
          path: '/snmpconfig',
          name: 'snmpConfig',
          component: Snmp
        },
        {
          path: '/gponconfig',
          name: 'gponconfig',
          component: GponConfig
        },
        {
          path: '/gponfindont',
          name: 'gponFindOnt',
          component: GponFindOnt
        },
        {
          path: '/ontbrief',
          name: 'ontbrief',
          component: OntBrief
        },
        {
          path: '/ontInfo',
          name: 'ontInfo',
          component: OntInfo
        },
        {
          path: '/ontOptical',
          name: 'ontOptical',
          component: OntOptical
        },
        {
          path: '/ontmactablelist',
          name: 'ontMacTableList',
          component: OntMacTableList
        },
        {
          path: '/ontupgrade',
          name: 'ontUpgrade',
          component: OntUpgrade
        },
        {
          path: '/systemTime',
          name: 'systemTime',
          component: SystemTime
        },
        {
          path: '/mirrorCfg',
          name: 'mirrorCfg',
          component: MirrorCfg
        },
        {
          path: '/profiledba',
          name: 'profiledba',
          component: ProfileDba
        },

        {
          path: '/profilevlan',
          name: 'profilevlan',
          component: ProfileVlan
        },

        {
          path: '/profilevlanrule/:profileId',
          name: 'profilevlanrule',
          component: ProfileVlanRule,
          props: true
        },

        {
          path: '/profileus',
          name: 'profileus',
          component: ProfileUs
        },

        {
          path: '/profileds',
          name: 'profileds',
          component: ProfileDs
        },

        {
          path: '/profilerule',
          name: 'profilerule',
          component: ProfileRule
        },

        {
          path: '/profilelinepri',
          name: 'profilelinepri',
          component: ProfilelinePri
        },

        {
          path: '/profilelinestep/:profileId',
          name: 'profilelinestep',
          component: ProfilelineStep,
          props: true
        },
        {
          path: '/profileunique',
          name: 'profileUnique',
          component: ProfileUnique
        },
        {
          path: '/profileUniqueconfig',
          name: 'profileUniqueConfig',
          component: ProfileUniqueConfig
        },
        {
          path: '/profilealarm',
          name: 'ProfileAlarm',
          component: ProfileAlarm
        },
        {
          path: '/profilemulticast',
          name: 'profileMulticast',
          component: ProfileMulticast
        },
        {
          path: '/profilemulticastentry',
          name: 'profileMulticastEntry',
          component: ProfileMulticastEntry
        },
        {
          path: '/profilemulticastentryinfo',
          name: 'profileMulticastEntryInfo',
          component: ProfileMulticastEntryInfo
        },
        {
          path: '/devicemanagement',
          name: 'deviceManagement',
          component: DeviceManagement
        },
        {
          path: '/userconfig',
          name: 'userconfig',
          component: UserConfig
        },

        {
          path: '/auxip',
          name: 'auxip',
          component: AuxIp
        },

        {
          path: '/stp',
          name: 'stp',
          component: Stp
        },

        {
          path: '/dhcp',
          name: 'dhcp',
          component: Dhcp
        },

        {
          path: '/dhcpoption82',
          name: 'dhcpoption82',
          component: DhcpOption82
        },
        
        {
          path: '/stormcontrol',
          name: 'stormcontrol',
          component: StormControl
        },

        {
          path: '/diagnose',
          name: 'diagnose',
          component: Diagnose
        },
      ]
    },

  ]
})
